import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Basicdetailsclicked from "../../../assets/images/Basicdetailsclicked.png";
import { useDispatch, useSelector } from "react-redux";
import { appContextConstants } from '../../../constants/appContext.constants';
import VerificationTab from "../../VerificationTab/VerificationTab";
import StatusBar from "../SatusBar/StatusBar";
import { userActions } from "../../../actions/user.actions";
import axiosInstance from "../../../helpers/axios";
import DetailsCard from "./DetailsCard";
import ProfileCard from "./ProfileCard";
import TabNavigation from "./TabNavigation";
import Disbursal from "./TabCards/Disbursal";
import LoanDetails from "./TabCards/LoanDetails";
import Sanction from "./TabCards/Sanction";
import IncomeAndCibil from "./TabCards/IncomeAndCibil";
import Kyc from "./TabCards/Kyc";
import BasicDetails from "./TabCards/BasicDetails";
import { useCurrentUser } from '../../../hooks/useCurrentUser';

function ApplicationProfile() {
  const [status, setStatus] = useState("");
  const decode = useCurrentUser();
  const user = null;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { appId: reduxAppId, userId: reduxUserId, coappId: reduxCoappId, status: reduxStatus } = useSelector(state => state.appContext);

  // local state instead of Redux
  const [bankSelfieData, setBankSelfieData] = useState(null);
  const [applicationDetails, setApplicationDetails] = useState(null);
  const [emiTable, setEmiTable] = useState(null);
  const [appUserId, setAppUserId] = useState(null);
  const [mandateDetails, setMandateDetails] = useState(null);

  const [open, setOpen] = useState();
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const [isImageClicked1, setIsImageClicked1] = useState(true);
  const [isImageClicked2, setIsImageClicked2] = useState(false);
  const [isImageClicked3, setIsImageClicked3] = useState(false);
  const [isImageClicked4, setIsImageClicked4] = useState(false);
  const [isImageClicked5, setIsImageClicked5] = useState(false);
  const [isImageClicked6, setIsImageClicked6] = useState(false);
  const [isImageClicked7, setIsImageClicked7] = useState(false);

  const [showCards1, setShowCards1] = useState(true);
  const [showCards2, setShowCards2] = useState(false);
  const [showCards3, setShowCards3] = useState(false);
  const [showCards4, setShowCards4] = useState(false);
  const [showCards5, setShowCards5] = useState(false);
  const [showCards6, setShowCards6] = useState(false);
  const [showCards7, setShowCards7] = useState(false);

  const handleToggle = (id) => {
    toggle(id);
    if (id === "1") {
      setShowCards1(true);
      setIsImageClicked1(true);
    } else {
      setShowCards1(false);
      setIsImageClicked1(false);
    }
    if (id === "2") {
      setShowCards2(true);
      setIsImageClicked2(true);
    } else {
      setShowCards2(false);
      setIsImageClicked2(false);
    }
    if (id === "3") {
      setShowCards3(true);
      setIsImageClicked3(true);
    } else {
      setShowCards3(false);
      setIsImageClicked3(false);
    }
    if (id === "4") {
      setShowCards4(true);
      setIsImageClicked4(true);
    } else {
      setShowCards4(false);
      setIsImageClicked4(false);
    }
    if (id === "5") {
      setShowCards5(true);
      setIsImageClicked5(true);
    } else {
      setShowCards5(false);
      setIsImageClicked5(false);
    }
    if (id === "6") {
      setShowCards6(true);
      setIsImageClicked6(true);
    } else {
      setShowCards6(false);
      setIsImageClicked6(false);
    }
    if (id === "7") {
      setShowCards7(true);
      setIsImageClicked7(true);
    } else {
      setShowCards7(false);
      setIsImageClicked7(false);
    }
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
    handleNavigateActivity();
  };
  const handleCloseDialog = () => setIsDialogOpen(false);

  const handleNavigateActivity = () => {
    const appId = reduxAppId;
    if (applicationDetails) {
      dispatch({ type: appContextConstants.SET_ACTIVITY_CONTEXT, payload: {
        activityUserId: reduxUserId,
        activityAppId: appId,
        activityAppLegacyLoanId: applicationDetails?.profile?.disbursementData?.legacyLoanId,
        activityAppLoanId: applicationDetails?.profile?.disbursementData?.loanId,
        activityAppStatus: applicationDetails?.status,
      }});
    }
  };

  const handleMandateDetails = (Emandate) => {
    setMandateDetails(Emandate);
  };

  useEffect(() => {
    const appId = reduxAppId;
    if (!appId) return;

    const fetchData = async () => {
      try {
        const requests = [
          axiosInstance.get(
            `/integrations/application-profile?applicationId=${appId}`,
            {
            }
          ),
          axiosInstance.get(
            `/admin/application/application-profile?applicationId=${appId}`,
            {
            }
          ),
        ];

        // Only fetch EMI if status is Disbursed
        const statusFromSession = reduxStatus;
        if (statusFromSession === "Disbursed") {
          requests.push(
            axiosInstance.get(`/emis?applicationId=${appId}`, {
            })
          );
        }

        const responses = await Promise.allSettled(requests);
        const bankSelfieRes = responses[0]?.status === "fulfilled" ? responses[0].value : null;
        const applicationDetailsRes = responses[1]?.status === "fulfilled" ? responses[1].value : null;
        const emiRes = responses[2]?.status === "fulfilled" ? responses[2].value : null;

        const bankSelfie = bankSelfieRes?.data?.data;
        const appDetails = applicationDetailsRes?.data?.data;
        const emi = emiRes?.data?.data;

        setBankSelfieData(bankSelfie);
        setApplicationDetails(appDetails);
        if (emi) {
          setEmiTable(emi);
        }

        const userIdFromApp = appDetails?.profile?.userDetails?.userId;
        if (userIdFromApp) {
          dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { userId: userIdFromApp } });
          setAppUserId(userIdFromApp);
        }

        setStatus(appDetails?.status || "");
      } catch (err) {
        console.error("Error fetching initial data", err);
      }
    };

    fetchData();
  }, [user, reduxAppId, reduxStatus]);

  const [popUp, setpopUp] = useState(false);
  const handleMobileDetails = () => {
    setpopUp(!popUp);
  };
  const [popUp1, setpopUp1] = useState(false);
  const handleCoappMobileDetails = () => {
    setpopUp1(!popUp1);
  };

  const statusIndex = {
    submission: "In Submission",
    Review: "In Review",
    Process: "In Process",
    Pending: "Pending Disbursement",
    onHold: "On Hold",
    dropped: "Dropped",
    rejected: "Rejected",
    sanction: "In Sanction",
    disbursement: "Ready to Disburse",
    disbursed: "Disbursed",
  };

  const formattedStatus =
    Object.keys(statusIndex).find((key) => statusIndex[key] === status) ||
    status;

  const handleUser = (event) => {
    const Id = reduxUserId;
    const applId = reduxAppId;
    const coAppId = reduxCoappId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: Id } });
    // const urlProfile = `/summary/user?id=${Id}&applicationId=${applId}&status=${status}`;

    // dispatch(
    //   userActions.fetchHandleuser(urlProfile, user, navigate, applId, Id),
    //   []
    // );

    // const ckycUrl = `/ckyc/details?userId=${Id}`;
    // const digilockerUrl = `/digilocker/details?applicationId=${applId}&userId=${Id}`;
    // const panUrl = `/application/pan-details?userId=${Id}&applicationId=${applId}`;
    // const bankSelfieUrl = `/integrations/details?applicationId=${applId}&userId=${Id}`;
    // const uploadedFileUrl = `/users/documents/admin?userId=${Id}`;
    // const getActivityUrl = `/audit?applicationId=${applId}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${applId}`;
    // const urlCIBIL = `/cibil/report?userId=${Id}`;
    // const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${applId}`;
    // const getFoirRefUrl = `/admin/application/additional-info?applicationId=${applId}`;

    // dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile, user));
    // dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    // dispatch(userActions.getCkycDetails(ckycUrl, user));
    // dispatch(userActions.getCibilDetails(urlCIBIL));
    // dispatch(userActions.getPanStatus(panUrl));
    // dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
    // dispatch(userActions.getDigiLocker(digilockerUrl, user));
    // dispatch(userActions.getProfileDetails(urlProfile));
    // dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
    // dispatch(userActions.getActivity(getActivityUrl, user));

    navigate(`/status/${formattedStatus}/profile`, {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: coAppId,
        applicationId: applId,
        dir: `${status}`,
        coapplicants: location?.state?.coapplicants,
        name: location?.state?.name,
      },
    });
  };

  const handleCoApp = (coApp, currTab) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { selectedUserId: coApp?.coapplicantId } });
    const Id = coApp?.coapplicantId ? coApp?.coapplicantId : reduxCoappId;
    const applId = reduxAppId;
    const userId = reduxUserId;
    const urlProfile = `/summary/coapplicant?id=${Id}&status=${status}`;

    dispatch(
      userActions.fetchHandlcoappuser(urlProfile, user, navigate, applId, Id),
      []
    );

    // const ckycUrl = `/ckyc/details?userId=${Id}`;
    // const profileUrl = `/summary/coapplicant?id=${Id}&status=${status}`;
    // const digilockerUrl = `/digilocker/details?applicationId=${applId}&userId=${Id}`;
    // const panUrl = `/application/pan-details?userId=${Id}&applicationId=${applId}`;
    // const bankSelfieUrl = `/integrations/details?applicationId=${applId}&userId=${Id}`;
    // const uploadedFileUrl = `/users/documents/admin?userId=${Id}`;
    // const getActivityUrl = `/audit?applicationId=${applId}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${applId}`;
    // const urlCIBIL = `/cibil/report?userId=${Id}`;
    // const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${applId}`;
    // const getFoirRefUrl = `/admin/application/additional-info?applicationId=${applId}`;

    // dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile, user));
    // dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    // dispatch(userActions.getCkycDetails(ckycUrl, user));
    // dispatch(userActions.getCibilDetails(urlCIBIL));
    // dispatch(userActions.getPanStatus(panUrl));
    // dispatch(userActions.getBankSelfieDetails(bankSelfieUrl, user));
    // dispatch(userActions.getDigiLocker(digilockerUrl, user));
    // dispatch(userActions.getProfileDetails(profileUrl));
    // dispatch(userActions.getUploadedFiles(uploadedFileUrl, user));
    // dispatch(userActions.getActivity(getActivityUrl, user));

    navigate(`/status/${formattedStatus}/profile`, {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: userId,
        coapplicantId: Id,
        applicationId: applId,
        dir: `${status}`,
        coapplicants: location?.state?.coapplicants,
        name: location?.state?.name,
      },
    });
  };

  const [selfiePath, setSelfiePath] = useState(null);

  useEffect(() => {
    const selfie = bankSelfieData?.selfieDetails?.selfie;
    if (!selfie) return;

    const url = `/file/url-content?path=${selfie}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setSelfiePath(res?.data?.data);
      })
      .catch((err) => console.error("Error fetching selfie url", err));
  }, [bankSelfieData]);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
      }}
    >
        <div>
          <ProfileCard
            applicationDetails={applicationDetails}
            selfiePath={selfiePath}
            location={location}
            bankSelfieData={bankSelfieData}
            handleOpenDialog={handleOpenDialog}
            isDialogOpen={isDialogOpen}
            handleCloseDialog={handleCloseDialog}
            handleUser={handleUser}
            handleCoApp={handleCoApp}
            status={status}
          />
          <DetailsCard
            applicationDetails={applicationDetails}
            appUserId={appUserId}
            status={status}
          />
          {decode?.clientId === "98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? (
            <StatusBar
              status={status}
              handleToggle={handleToggle}
              isImageClicked1={isImageClicked1}
              isImageClicked2={isImageClicked2}
              isImageClicked3={isImageClicked3}
              isImageClicked4={isImageClicked4}
              isImageClicked5={isImageClicked5}
              isImageClicked6={isImageClicked6}
              isImageClicked7={isImageClicked7}
              Basicdetailsclicked={Basicdetailsclicked}
              bankSelfieData={bankSelfieData}
              handleMandateDetails={handleMandateDetails}
            />
          ) : (
            <TabNavigation
              status={status}
              handleToggle={handleToggle}
              handleMandateDetails={handleMandateDetails}
              isImageClicked1={isImageClicked1}
              isImageClicked2={isImageClicked2}
              isImageClicked3={isImageClicked3}
              isImageClicked4={isImageClicked4}
              isImageClicked5={isImageClicked5}
              isImageClicked6={isImageClicked6}
              bankSelfieData={bankSelfieData}
            />
          )}

          {showCards1 && (
            <BasicDetails
              applicationDetails={applicationDetails}
              setIsExpanded={setIsExpanded}
              isExpanded={isExpanded}
              handleMobileDetails={handleMobileDetails}
              popUp={popUp}
              setpopUp={setpopUp}
              handleCoappMobileDetails={handleCoappMobileDetails}
              setpopUp1={setpopUp1}
              popUp1={popUp1}
            />
          )}
          {showCards2 && (
            <Kyc
              applicationDetails={applicationDetails}
              bankSelfieData={bankSelfieData}
              setIsExpanded={setIsExpanded}
              isExpanded={isExpanded}
            />
          )}
          {showCards3 && (
            <IncomeAndCibil
              applicationDetails={applicationDetails}
              bankSelfieData={bankSelfieData}
              setIsExpanded={setIsExpanded}
              isExpanded={isExpanded}
            />
          )}
          {showCards4 && (
            <Sanction
              applicationDetails={applicationDetails}
              mandateDetails={mandateDetails}
              setIsExpanded={setIsExpanded}
              isExpanded={isExpanded}
            />
          )}
          {showCards5 && <Disbursal applicationDetails={applicationDetails} decode={decode} />}
          {showCards6 && (
            <LoanDetails
              emidetails={emiTable}
              emiTable={emiTable}
              applicationDetails={applicationDetails}
            />
          )}
          {showCards7 && (
            <VerificationTab
              applicationDetails={applicationDetails}
              user={user}
            />
          )}
        </div>
    </div>
  );
}

export default ApplicationProfile;
